module.exports = __webpack_public_path__ + "img/builds@2x.cb9f3549.jpg";